(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wj-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class WJAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.wj-accordion-item');
      }

      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);

        // Listen for wj-color-switch event to filter items by color group
        document.addEventListener('wj-color-switch', (e) => {
          if (e.detail && typeof e.detail.index === 'number') {
            this.filterByColorGroup(String(e.detail.index));
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('wj-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.wj-accordion-item-container');
        if (!galleryContainer) return;

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 16,
          slidesPerView: 1.2,
          autoHeight: true,
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
          breakpoints: {
            220: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            500: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
          },
        });

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      filterByColorGroup(colorIndex) {
        const items = this.querySelectorAll('.wj-accordion-item');
        let firstVisible = null;
        items.forEach((item) => {
          const group = item.dataset.colorGroup || '0';
          if (group === colorIndex) {
            item.style.display = '';
            if (!firstVisible) firstVisible = item;
          } else {
            item.style.display = 'none';
            item.classList.remove('active');
          }
        });
        // Set first visible item as active
        if (firstVisible) {
          firstVisible.classList.add('active');
          this.currentActiveItem = firstVisible;
        }

        // Rebuild swiper if in mobile mode
        if (this.isMobileMode && this.swiperInstance) {
          this.destroySwiper();
          setTimeout(() => this.initSwiper(), 50);
        }

        // Re-add hover listeners on PC
        if (!this.isMobileMode) {
          this.removeHoverListeners();
          this.addHoverListeners();
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 1025;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 延迟初始化轮播，确保DOM已准备好
            setTimeout(() => this.initSwiper(), 50);
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('wj-accordion')) {
      window.customElements.define('wj-accordion', WJAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }
  
      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }
  
      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }
  
      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }
  
      initSwiper() {
        if (this.swiperInstance) return;
  
        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
          return;
        }
  
        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) return;
  
        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 16,
          slidesPerView: 'auto',
          autoHeight: true,
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            }
          },
          breakpoints: {
            320: {
              spaceBetween: 16
            },
            768: {
              spaceBetween: 16
            },
            990: {
              spaceBetween: 16,
            },
          },
        });
  
        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }
  
      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }
  
      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 1025;
        const modeChanged = shouldBeMobile !== this.isMobileMode;
  
        // 更新当前模式
        this.isMobileMode = shouldBeMobile;
  
        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 延迟初始化轮播，确保DOM已准备好
            setTimeout(() => this.initSwiper(), 50);
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }
  
        // 标记初始化完成
        this.isInitializing = false;
      }
  
      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }
  
      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }
  
      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }
  
      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }
  
      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;
  
        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }
  
    if (!window.customElements.get('yg-accordion')) {
      window.customElements.define('yg-accordion', YGAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-member-photo-wall"] && !Shopify.designMode) return;
  try {
    
  class YGMemberPhotoWallElement extends HTMLElement {
    constructor() {
      super();
      // bound callbacks so they can be added/removed reliably
      this._intersectionCallback = this._intersectionCallback.bind(this);
      this._onResize = this._onResize.bind(this);
      this._observer = null;
    }

    connectedCallback() {
      // Initialize observer when element is attached (only active on small screens)
      this._initObserver();
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      // Cleanup when element is removed
      this._disconnectObserver();
      window.removeEventListener('resize', this._onResize);
    }

    // Create IntersectionObserver and start observing this element
    _initObserver() {
      // Only initialize on small screens
      if (window.innerWidth >= 700) {
        // ensure active class is removed when not in small-screen mode
        this._removeActive();
        return;
      }

      if (this._observer) return;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(this._intersectionCallback, {
          root: null,
          rootMargin: '0px',
          threshold: [0, 0.75, 1]
        });
        this._observer.observe(this);
      } else {
        // Fallback: immediately mark active for small screens
        this._addActive();
      }
    }

    // Disconnect and cleanup observer
    _disconnectObserver() {
      if (!this._observer) return;
      try {
        this._observer.unobserve(this);
        this._observer.disconnect();
      } catch (err) {
        // ignore cleanup errors
      }
      this._observer = null;
    }

    // Handle window resize: enable/disable observer when crossing 700px breakpoint
    _onResize() {
      const isSmall = window.innerWidth < 700;
      const hasObserver = !!this._observer;
      if (isSmall && !hasObserver) {
        this._initObserver();
      } else if (!isSmall && hasObserver) {
        this._disconnectObserver();
        this._removeActive();
      }
    }

    // IntersectionObserver callback - separated for testability
    _intersectionCallback(entries) {
      for (const entry of entries) {
        if (entry.target !== this) continue;
        const ratio = entry.intersectionRatio || 0;
        if (entry.isIntersecting && ratio >= 0.75) {
          this._addActive();
        } else {
          this._removeActive();
        }
      }
    }

    // Add active class if not present
    _addActive() {
      if (!this.classList.contains('active')) {
        this.classList.add('active');
      }
    }

    // Remove active class if present
    _removeActive() {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
    }
  }

  if (!window.customElements.get('yg-member-photo-wall')) {
    window.customElements.define('yg-member-photo-wall', YGMemberPhotoWallElement);
  }

  } catch(e) { console.error(e); }
})();
})();
